import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=13df0d63&scoped=true&"
import script from "./ProfileData.vue?vue&type=script&lang=js&"
export * from "./ProfileData.vue?vue&type=script&lang=js&"
import style0 from "./ProfileData.vue?vue&type=style&index=0&id=13df0d63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df0d63",
  null
  
)

export default component.exports